export const LIVE_CALLS_POLL_MS = 5000

export const compactCellSx = { py: 0.75, px: 1 }

export const coachPhaseLabels: Record<string, string> = {
  idle: "Sin conexión",
  connecting: "Conectando…",
  open: "Coach activo",
  closed: "Desconectado",
  error: "Error",
}
